import { Navigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeading } from '../components/PageHeader';
import { TeamTab, useTeamAvailability } from '../components/Agency/team/TeamTab';
import { TeamRolesTab } from '../components/Agency/team/TeamRoles';
import { useAuth } from '../context/AuthContext';

/** Agency → Team (ADR 0031): who works on which Accounts, with what. */
export function TeamPage() {
  const { t } = useTranslation('agency');
  const [searchParams] = useSearchParams();
  // Team is only for people with something to manage: accounts they own, or an
  // agency they co-manage. Plain agency members and pure chatters don't get it.
  const teamAvailable = useTeamAvailability();
  // Team with Roles (Team Simplified 1a) — stage 1: super admins only;
  // ?team=classic opens the previous page.
  const { isSuperAdmin } = useAuth();
  const withRoles = isSuperAdmin && searchParams.get('team') !== 'classic';

  if (teamAvailable === false) return <Navigate to="/" replace />;

  return (
    <div className="mobile-page-shell cpt-root w-full px-6 pt-5 pb-6 min-w-0" style={{ display: 'flex', flexDirection: 'column', gap: 14, boxSizing: 'border-box' }}>
      <PageHeading title={t('tabs.team')} subtitle={t('pages.teamSubtitle')} />
      {teamAvailable && (withRoles ? <TeamRolesTab /> : <TeamTab />)}
    </div>
  );
}
